module.exports = __webpack_public_path__ + "img/afsorde.a5875124.svg";